module.exports = __webpack_public_path__ + "media/images/goods-1ac474d5.svg";